import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import IconoANSES from './IconoANSES';
import useNotificacionesAnses, { RUTA_SEGUIMIENTO } from '../hooks/useNotificacionesAnses';
import 'bootstrap/dist/css/bootstrap.min.css';

// Campana exclusiva de notificaciones de Seguimiento de Expedientes ANSES (origen === 'ANSES').
// Mismo comportamiento de popover que NotificacionCampana, pero separada para que estas
// notificaciones dejen de mezclarse con la campana general (ver NotificacionCampana.js).
const NotificacionCampanaANSES = () => {
    const [popoverVisible, setPopoverVisible] = useState(false);
    const popoverRef = useRef(null);
    const navigate = useNavigate();

    const {
        notificaciones, loading, nuevasCount, hayNoLeidas, marcandoTodas,
        abrirNotificacion: abrirNotificacionHook,
        marcarTodasLeidas: marcarTodasLeidasHook,
        descartar,
    } = useNotificacionesAnses();

    const abrirNotificacion = (notif) => {
        abrirNotificacionHook(notif, { onNavegar: () => setPopoverVisible(false) });
    };

    const marcarTodasLeidas = (e) => {
        e.stopPropagation();
        marcarTodasLeidasHook();
    };

    const handleDescartar = (e, idNotificacion) => {
        e.stopPropagation();
        descartar(idNotificacion);
    };

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (popoverRef.current && !popoverRef.current.contains(e.target)) {
                setPopoverVisible(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="position-relative d-flex align-items-center justify-content-center" ref={popoverRef} style={{ width: '100%', height: '100%' }}>
            <button
                className="btn position-relative p-0 border-0 d-flex align-items-center justify-content-center"
                title="Seguimiento de Expedientes ANSES"
                onClick={() => setPopoverVisible(!popoverVisible)}
                style={{ width: '100%', height: '100%', transition: 'transform 0.25s ease' }}
                onMouseEnter={e => (e.currentTarget.style.transform = 'scale(1.15)')}
                onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
            >
                <IconoANSES size={39} color={hayNoLeidas ? '#ffc107' : 'white'} />
                {hayNoLeidas && (
                    <span
                        className="position-absolute rounded-circle"
                        style={{ width: '14px', height: '14px', top: '16%', right: '12%', backgroundColor: '#ffc107' }}
                    />
                )}
                {nuevasCount > 0 && (
                    <span
                        className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning text-dark"
                        style={{ fontSize: '0.9rem', minWidth: '28px', padding: '0.35rem 0.5rem' }}
                    >
                        {nuevasCount > 99 ? '99+' : nuevasCount}
                    </span>
                )}
            </button>

            {popoverVisible && (
                <div
                    className="position-absolute end-0"
                    style={{
                        top: '100%',
                        marginTop: '10px',
                        width: '420px',
                        maxWidth: '94vw',
                        background: '#fff',
                        border: '1px solid #e2e8f0',
                        borderRadius: '12px',
                        boxShadow: 'var(--shadow-lg)',
                        zIndex: 3000,
                        overflow: 'hidden',
                    }}
                >
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '14px 16px 12px',
                        borderBottom: '1px solid #e2e8f0',
                        background: '#1e40af',
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <i className="bi bi-folder2-open" style={{ color: '#93c5fd', fontSize: '1rem' }} />
                            <span style={{ fontWeight: 700, color: '#fff', fontSize: '0.95rem' }}>Seguimiento de Expedientes</span>
                            {nuevasCount > 0 && (
                                <span style={{
                                    background: '#fbbf24', color: '#1e293b', borderRadius: '20px',
                                    padding: '1px 9px', fontSize: '0.72rem', fontWeight: 700,
                                }}>
                                    {nuevasCount} nueva{nuevasCount !== 1 ? 's' : ''}
                                </span>
                            )}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            {nuevasCount > 0 && (
                                <button
                                    type="button"
                                    onClick={marcarTodasLeidas}
                                    disabled={marcandoTodas}
                                    title="Marcar todas como leídas"
                                    style={{
                                        background: 'rgba(255,255,255,0.12)', border: 'none', borderRadius: 6,
                                        color: '#fff', cursor: marcandoTodas ? 'default' : 'pointer', padding: '3px 9px', fontSize: '0.78rem',
                                        fontWeight: 600, lineHeight: 1.6, opacity: marcandoTodas ? 0.6 : 1,
                                    }}
                                >
                                    {marcandoTodas ? 'Marcando…' : 'Marcar leídas'}
                                </button>
                            )}
                            <button
                                type="button"
                                onClick={() => { setPopoverVisible(false); navigate(RUTA_SEGUIMIENTO); }}
                                title="Ir a Seguimiento de Expedientes"
                                style={{
                                    background: 'rgba(255,255,255,0.12)', border: 'none', borderRadius: 6,
                                    color: '#fff', cursor: 'pointer', padding: '3px 9px', fontSize: '0.78rem',
                                    fontWeight: 600, lineHeight: 1.6,
                                }}
                            >
                                Ver todas
                            </button>
                            <button
                                type="button"
                                onClick={() => setPopoverVisible(false)}
                                style={{
                                    background: 'rgba(255,255,255,0.12)', border: 'none', borderRadius: 6,
                                    color: '#fff', cursor: 'pointer', padding: '3px 8px', fontSize: '0.95rem',
                                    lineHeight: 1,
                                }}
                            >
                                <i className="bi bi-x-lg" />
                            </button>
                        </div>
                    </div>

                    <div style={{ maxHeight: '440px', overflowY: 'auto' }}>
                        {loading ? (
                            <div style={{ textAlign: 'center', padding: '28px 16px', color: '#94a3b8' }}>
                                <div className="spinner-border spinner-border-sm text-primary mb-2" />
                                <div style={{ fontSize: '0.85rem' }}>Cargando…</div>
                            </div>
                        ) : notificaciones.length === 0 ? (
                            <div style={{ textAlign: 'center', padding: '36px 16px', color: '#94a3b8' }}>
                                <i className="bi bi-folder2" style={{ fontSize: '2rem', display: 'block', marginBottom: 8 }} />
                                <div style={{ fontSize: '0.88rem' }}>Sin novedades de expedientes</div>
                            </div>
                        ) : (
                            notificaciones.map(item => {
                                const leida = item?.leido === true;
                                const accentColor = '#2563eb';
                                const fecha = item.fechaProgramada ? new Date(item.fechaProgramada) : null;
                                return (
                                    <div
                                        key={item.id}
                                        onClick={() => abrirNotificacion(item)}
                                        style={{
                                            display: 'flex',
                                            gap: 12,
                                            padding: '12px 16px',
                                            borderBottom: '1px solid #f1f5f9',
                                            cursor: 'pointer',
                                            background: leida ? '#fff' : '#f0f7ff',
                                            transition: 'background 0.12s',
                                            position: 'relative',
                                        }}
                                        onMouseEnter={e => { e.currentTarget.style.background = leida ? '#f8fafc' : '#dbeafe'; }}
                                        onMouseLeave={e => { e.currentTarget.style.background = leida ? '#fff' : '#f0f7ff'; }}
                                    >
                                        <div style={{
                                            width: 3, borderRadius: 4, background: leida ? '#e2e8f0' : accentColor,
                                            flexShrink: 0, alignSelf: 'stretch',
                                        }} />

                                        <div style={{
                                            width: 32, height: 32, borderRadius: '50%',
                                            background: leida ? '#f1f5f9' : `${accentColor}18`,
                                            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                                        }}>
                                            <i className="bi bi-folder2-open" style={{ color: leida ? '#94a3b8' : accentColor, fontSize: '0.9rem' }} />
                                        </div>

                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <div style={{
                                                fontSize: '0.86rem', fontWeight: leida ? 400 : 600,
                                                color: leida ? '#64748b' : '#1e293b', lineHeight: 1.4,
                                                marginBottom: 5,
                                                overflow: 'hidden', display: '-webkit-box',
                                                WebkitLineClamp: 3, WebkitBoxOrient: 'vertical',
                                            }}>
                                                {item.mensaje}
                                            </div>
                                            {fecha && (
                                                <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                                                    <span style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: '0.74rem', color: '#94a3b8', fontVariantNumeric: 'tabular-nums' }}>
                                                        <i className="bi bi-calendar3" style={{ fontSize: '0.7rem' }} />
                                                        {fecha.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                                                    </span>
                                                    <span style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: '0.74rem', color: '#94a3b8', fontVariantNumeric: 'tabular-nums' }}>
                                                        <i className="bi bi-clock" style={{ fontSize: '0.7rem' }} />
                                                        {fecha.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' })}
                                                    </span>
                                                </div>
                                            )}
                                        </div>

                                        <button
                                            type="button"
                                            aria-label="Descartar"
                                            onClick={(e) => handleDescartar(e, item.id)}
                                            style={{
                                                background: 'none', border: 'none', cursor: 'pointer',
                                                color: '#94a3b8', padding: '2px 4px', borderRadius: 4,
                                                fontSize: '0.8rem', alignSelf: 'flex-start', flexShrink: 0,
                                                lineHeight: 1,
                                            }}
                                            onMouseEnter={e => { e.currentTarget.style.color = '#475569'; e.currentTarget.style.background = '#f1f5f9'; }}
                                            onMouseLeave={e => { e.currentTarget.style.color = '#94a3b8'; e.currentTarget.style.background = 'none'; }}
                                        >
                                            <i className="bi bi-x-lg" />
                                        </button>
                                    </div>
                                );
                            })
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default NotificacionCampanaANSES;
